import { Stack, Box, Typography } from '@mui/material';

export const ExperiencesListStatus = () => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 450px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center" spacing={2}>
        <Typography fontSize={24} fontWeight={600} color="#202227">
          No Experiences Found.
        </Typography>
      </Stack>
    </Box>
  );
};
